import { Mold } from '../types/mold';

// Utility: set value at a nested path (dot notation) in an object (immutable)
export const setNestedValue = <T extends object>(obj: T, path: string, value: any): T => {
    const keys = path.split('.');
    if (keys.length === 1) {
        return { ...obj, [path]: value };
    }
    const [first, ...rest] = keys;
    return {
        ...obj,
        [first]: setNestedValue((obj as any)[first] || {}, rest.join('.'), value)
    };
};

export const isNestedKey = (key: string) => key.includes('.');

// Utility: get value at a nested path (dot notation) in an object
export const getNestedValue = (obj: any, path: string): any => {
    if (!path.includes('.')) return obj?.[path];
    return path.split('.').reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj);
};

export const getUpdatedMold = (mold: Partial<Mold>, field: keyof Mold | string, value: any) => {
    if (field === 'customer') {
        return {
            ...mold,
            customer: {
                ...mold.customer,
                ...value,
            },
        };
    } else if (isNestedKey(field as string)) {
        return setNestedValue(mold, field as string, value);
    } else {
        return { ...mold, [field]: value };
    }
};